
























import { Component, Prop, Vue } from 'vue-property-decorator';
import VueLi from "vue-li-image";

@Component({
  components: {
    VueLi
  }
})
export default class BlogPost extends Vue {
    @Prop() private title: string;
    @Prop() private explain: string;
    @Prop() private img: string;
    @Prop() private date: string;
    @Prop() private link: string;
    private readonly static_server = "https://static.ty-sb1.tayeh.ir/tayeh-panel/assets/images/"
  }
